/**
 * Convert a tracking context ({ page, surface }) to X-Delve-* headers.
 * Returns null when no context is provided so callers can pass the result
 * straight to API.post/put/delete without polluting ordinary requests.
 * See docs/coding-tracking-plan.md.
 */
export function trackingHeaders(trackingContext) {
  if (!trackingContext) return null;
  const headers = {};
  if (trackingContext.page) headers['X-Delve-Page'] = trackingContext.page;
  if (trackingContext.surface) headers['X-Delve-Surface'] = trackingContext.surface;
  return Object.keys(headers).length > 0 ? headers : null;
}
